import ControlCheckboxes from "components/Critics/ControlCheckboxes"
import AddNewsActions from "components/News/AddActions"
import HeaderPodsNews from "components/News/HeaderPods"

import { ComponentProps } from "."
import Main from "./Main"
import { Wrapper } from "./styled"

const Add = ({
  actionCheckboxes,
  areNewsSourcesLoading,
  avNirvana,
  bluRay,
  clearAllListsButtonProps,
  clearListButtonProps,
  hidefDigest,
  isAdmin,
  isEditor,
  listAllButtonProps,
  listButtonProps,
  loadMoreButtonProps,
  news,
  newsAddActionsProps,
  newsCards,
  newsControlCheckboxesProps,
  onClear,
  onSetOverrides,
  siteConfigNews,
  whySoBlu
}: ComponentProps) => (
  <Wrapper>
    <ControlCheckboxes
      {...newsControlCheckboxesProps}
      isAdmin={isAdmin}
      isEditor={isEditor}
    />

    <HeaderPodsNews
      areNewsLoading={areNewsSourcesLoading}
      avNirvana={avNirvana}
      bluRay={bluRay}
      hidefDigest={hidefDigest}
      isCompact={Boolean(
        newsControlCheckboxesProps.isCompactCheckboxProps?.checked
      )}
      isSingleSource={Boolean(
        newsControlCheckboxesProps.isSingleSourceCheckboxProps?.checked
      )}
      left={
        <AddNewsActions
          {...newsAddActionsProps}
          isSingleSource={Boolean(
            newsControlCheckboxesProps.isSingleSourceCheckboxProps?.checked
          )}
        />
      }
      news={news}
      onClear={onClear}
      onSetOverrides={onSetOverrides}
      whySoBlu={whySoBlu}
    />

    {newsControlCheckboxesProps.isSingleSourceCheckboxProps?.checked ? null : (
      <Main
        actionCheckboxes={actionCheckboxes}
        clearAllListsButtonProps={clearAllListsButtonProps}
        clearListButtonProps={clearListButtonProps}
        isAdmin={isAdmin}
        isEditor={isEditor}
        listAllButtonProps={listAllButtonProps}
        listButtonProps={listButtonProps}
        loadMoreButtonProps={loadMoreButtonProps}
        newsCards={newsCards}
        siteConfigNews={siteConfigNews}
      />
    )}
  </Wrapper>
)

Add.whyDidYouRender = true

export default Add
